import { useState } from 'react';
import { useNotify } from 'react-admin';
import { API_BASE_URL_ADMIN } from 'shared/config';
import { API_URL } from 'shared/constants/api-url';
import { httpClient } from 'shared/services/http-client';

interface Arguments {
  companyId: string;
}

export const useSearchCompanyPatients = ({ companyId }: Arguments) => {
  const [isLoading, setIsLoading] = useState(false);
  const notify = useNotify();

  const url = API_URL.companyPatients(companyId);

  const searchCompanyPatients = async (data: { email: string }) => {
    setIsLoading(true);
    try {

      const params = new URLSearchParams({
        limit: '10',
        page: '1',
        email: data.email,
      });

      const response = await httpClient(`${API_BASE_URL_ADMIN}${url}?${params.toString()}`, {
        method: 'GET',
      });

      return response.json;
    } catch (error: any) {
      notify(error.message, { type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  return { searchCompanyPatients, isLoading };
};
